import type { ReactNode } from 'react';

/** Page title with optional actions. Actions drop under a long title (Croatian) instead of squeezing it. */
export function PageHeader({ title, children }: { title: string; children?: ReactNode }) {
  return (
    <div className="flex flex-wrap items-center justify-between gap-x-3 gap-y-2">
      <h1 className="min-w-0 text-2xl font-semibold md:text-3xl">{title}</h1>
      {children && <div className="flex items-center gap-2">{children}</div>}
    </div>
  );
}
